import Swal from 'sweetalert2'

export default class alertBox{
    static success(message,time = 1000){
        Swal.fire({
            width: 400,
            position: 'center',
            title: '',
            html: `<span style="font-size:16px;color:green;font-weight: bold">${message}</span>`,
            icon: 'success',
            showConfirmButton:false,
            timer: time
        })
    }
    static success2(message,color = 'green'){
        return Swal.fire({
            html: `<span style="font-size:14px;color:${color};font-weight: bold">${message}</span>`,
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: color,
            confirmButtonText: 'Ok',
        }).then((result) => {
            return (result.isConfirmed) ? true : false
      })
    }
    static error(message){
        Swal.fire({
            position: 'center',
            icon: 'error',
            html: `<span style="font-size:14px;color:red;font-weight: bold">${message}</span>`,
        })
    }
    static warning(message){
        Swal.fire({
            position: 'center',
            icon: 'warning',
            html: `<span style="font-size:14px;color:red;font-weight: bold">${message}</span>`,
        })
    }
    static  confirm(message){
        return Swal.fire({
                html: `<span style="font-size:14px;color:red;font-weight: bold">${message}</span>`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                //cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText : "No",
            }).then((result) => {
                return (result.isConfirmed) ? true : false
          })
    }
    static  confirm2(message){
        return Swal.fire({
                html: `<span style="font-size:14px;color:#3F51B5;font-weight: bold">${message}</span>`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#1f91f3',
                //cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText : "No",
            }).then((result) => {
                return (result.isConfirmed) ? true : false
          })
    }
    static  confirm3(message){
        return Swal.fire({
                html: message,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                //cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText : "No",
            }).then((result) => {
                return (result.isConfirmed) ? true : false
          })
    }
 }


// WEBPACK FOOTER //
// ./src/classes/alertBox.js